<template>
  <MediaStorageCropperProvider>
    <template #default="{ cropperProps }">
      <cropper
        class="cropper"
        v-bind="{
          ...cropperProps(tag).props,
          ...$attrs,
        }"
        v-on="$listeners"
        :debounce="300"
        ref="cropper"
        @ready="onCropperReady"
      ></cropper>
    </template>
  </MediaStorageCropperProvider>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import MediaStorageCropperProvider from "./MediaStorageCropperProvider.vue";

export default {
  props: {
    tag: {
      type: String,
      default: "",
    },
    fixedSize: {
      type: String,
      default: "",
    },
  },
  components: {
    Cropper,
    MediaStorageCropperProvider,
  },
  computed: {
    parsedFixedSize() {
      const [width, height] = this.fixedSize.split("/").map(Number);
      return { width, height };
    },
  },
  methods: {
    onCropperReady() {
      if (this.fixedSize && this.$refs.cropper) {
        const imageSize = this.$refs.cropper.imageSize;
        this.resizeWarningHandler(imageSize);
      }
    },

    resizeWarningHandler(imageSize) {
      const { width, height } = this.parsedFixedSize;
      if (imageSize?.width < width || imageSize?.height < height) {
        const message = `Image size is smaller than recommended (${width}x${height} pixels). Current size: ${imageSize?.width}x${imageSize?.height}. The image will be stretched, which may result in reduced quality.`;
        this.$emit("resize-warning", message);
      }
    },
    resizeToFixedSize(coordinates, canvas) {
      if (!this.fixedSize) return { coordinates, canvas };

      const { width, height } = this.parsedFixedSize;

      const resizedCanvas = document.createElement("canvas");
      resizedCanvas.width = width;
      resizedCanvas.height = height;

      const ctx = resizedCanvas.getContext("2d");
      ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, width, height);

      return {
        coordinates,
        canvas: resizedCanvas,
      };
    },
  },
  watch: {
    cropperProps: {
      handler() {
        const cropperRef = this.$refs.cropper;
        if (cropperRef) {
          cropperRef.update();
        }
      },
      deep: true,
    },
  },
};
</script>
